import React from 'react';
import '../CSS/style/style.css';
import tram from '../resource/tram.avif';
import net from '../resource/net.jpeg';
import fire from '../resource/fire.jpg';
import beer from '../resource/beer.avif';
import table from '../resource/table.jpeg';
import camp from '../resource/camp.jpeg';
import menu from '../resource/menu.jpeg';
import shower from '../resource/shower.avif';

const SECTIONS = [
    {
        label: 'FOOD & CONVENIENCE',
        title: '먹거리 & 편의시설',
        cols: 2,
        items: [
            {
                img: menu, alt: '매점 및 먹거리',
                title: '매점 & 먹거리',
                desc: '간단한 생필품·간식부터 치킨·백숙까지.\n펜션에서 즐기는 따끈한 한 끼!',
            },
            {
                img: beer, alt: '생맥주',
                title: '생맥주',
                desc: '계곡 옆에서 즐기는 시원한 생맥주.\n잊지 못할 한 잔의 여유.',
            },
        ],
    },
    {
        label: 'OUTDOOR',
        title: '야외 즐길거리',
        cols: 3,
        items: [
            {
                img: fire, alt: '숯불 BBQ',
                title: '숯불 BBQ',
                desc: '탁 트인 자연 속 바비큐 타임.\n숯·그릴 판매, 사전 신청 필수.',
            },
            {
                img: tram, alt: '트램폴린',
                title: '트램폴린',
                desc: '아이들이 뛰놀기 좋은 공간.\n보호자 동반 이용 바랍니다.',
            },
            {
                img: net, alt: '해먹',
                title: '해먹',
                desc: '나무 그늘 아래 편안한 휴식.\n바람 솔솔, 계곡 소리 가득.',
            },
        ],
    },
    {
        label: 'CAMPING',
        title: '캠핑 & 대여',
        cols: 2,
        items: [
            {
                img: camp, alt: '오토캠핑',
                title: '오토캠핑',
                desc: '캠핑카 또는 텐트로 즐기는 1박 2일.\n자연 속 특별한 캠핑 경험.',
            },
            {
                img: table, alt: '평상 대여',
                title: '평상 대여',
                desc: '계곡 옆 평상에서 여유로운 시간.\n물소리 들으며 쉬어가세요.',
            },
        ],
    },
    {
        label: 'FACILITIES',
        title: '편의시설',
        cols: 1,
        items: [
            {
                img: shower, alt: '야외 샤워실 및 화장실',
                title: '야외 샤워실 & 화장실',
                desc: '캠핑·바비큐 이용 손님을 위한 쾌적한 야외 샤워·화장실.',
            },
        ],
    },
];

const FEE_INFO = [
    {
        title: '🌿 평상 대여료',
        rows: [
            { label: '평일 (4인 기준)',  value: '50,000원 · 추가 1인 10,000원' },
            { label: '주말 3인 이하',    value: '50,000원' },
            { label: '주말 4인 기준',    value: '60,000원 · 추가 1인 10,000원' },
            { label: '이용 시간',        value: '오전 6시 ~ 자정 전' },
        ],
        notes: [
            '개별 쓰레기 봉투 지참 및 분리수거 필수',
            '이용 자리 정리 필수',
            '개수대·화장실·샤워실 이용 가능',
            '백숙·치킨·파전 등 음식 주문 가능',
            '주차 평상 1개당 1대',
            '환불 규정은 펜션과 동일',
        ],
    },
    {
        title: '🔥 숯불 BBQ 안내',
        rows: [
            { label: '2~4인',   value: '20,000원' },
            { label: '5~8인',   value: '30,000원' },
            { label: '숯 추가', value: '10,000원~' },
            { label: '운영 마감', value: '오후 10시' },
        ],
        notes: [
            '숯+그릴+석쇠 제공',
            '사전 예약 및 이용 1시간 전 신청 필수',
            '개별 바베큐장 또는 평상에 준비',
            '개별 장작·화로 사용 절대 불가',
        ],
    },
];

const Services = () => {
    return (
        <div className="main-wrapper">
            <section className="foot-banner"></section>

            <div className="service-container">
                <div className="section-header">
                    <span className="section-label">SERVICES</span>
                    <h2 className="section-title">물조은펜션 부대시설</h2>
                    <p className="section-desc">자연 속 힐링과 편안한 즐거움을 더해줄 다양한 서비스를 이용해보세요.</p>
                </div>

                {SECTIONS.map(({ label, title, cols, items }) => (
                    <div key={label} className="service-section">
                        <div className="section-header" style={{ margin: '56px 0 28px' }}>
                            <span className="section-label">{label}</span>
                            <h2 className="section-title">{title}</h2>
                        </div>
                        <div
                            className="service-card-grid"
                            style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}
                        >
                            {items.map(({ img, alt, title: t, desc }) => (
                                <div key={t} className="service-card">
                                    <img src={img} alt={alt} className="service-card-img" />
                                    <div className="service-card-body">
                                        <p className="service-card-title">{t}</p>
                                        <p className="service-card-desc">{desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

                <div className="main-divider"><span></span></div>

                <div className="section-header" style={{ margin: '0 0 28px' }}>
                    <span className="section-label">PRICING</span>
                    <h2 className="section-title">이용 요금 안내</h2>
                </div>
                <div className="service-fee-grid">
                    {FEE_INFO.map(({ title, rows, notes }) => (
                        <div key={title} className="service-fee-card">
                            <p className="service-fee-title">{title}</p>
                            {rows.map(({ label, value }) => (
                                <div key={label} className="service-fee-row">
                                    <span className="service-fee-label">{label}</span>
                                    <span className="service-fee-value">{value}</span>
                                </div>
                            ))}
                            <ul className="service-fee-notes">
                                {notes.map((n, i) => <li key={i}>{n}</li>)}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Services;